import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      content: {
        padding: theme.spacing(3, 0),
        paddingBottom: theme.spacing(3),
      },
      textSelectItens: {
        marginBottom: '10px',
        width: '100% !important'
      },
      emptyMessage: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: theme.spacing(2.5),
      },
      documentRemoving: {
        opacity: 0.5,
        pointerEvents: 'none',
      },
      documentName: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(4),
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        boxSizing: 'border-box',
        wordBreak: 'break-word',
      },
      documentButtonRemove: {
        textAlign: 'right',
        paddingRight: theme.spacing(4),
        boxSizing: 'border-box',
        '& .MuiIconButton-root': {
          fontSize: 11,
          padding: theme.spacing(1, 2),
          borderColor: sicrediColor.primarySicredi,
          color: sicrediColor.primarySicredi,
        }
      },
      documentButtonDownload: {
        paddingLeft: theme.spacing(3),
        boxSizing: 'border-box',
        visibility: 'visible',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
      },
      documentButtonOcultoDownload: {
        paddingLeft: theme.spacing(3),
        boxSizing: 'border-box',
        visibility: 'hidden'
      },
      documentDescription: {
        paddingLeft: theme.spacing(4),
        boxSizing: 'border-box',
        '& .MuiInputBase-root': {
          padding: theme.spacing(1, 2),
          '&.Mui-disabled': {
            padding: theme.spacing(1, 0),
            '& fieldset': {
              border: 'none',
            },
          },
          '& .MuiInputBase-input': {
            color: sicrediColor.secondarySicrediDarker,
          },
        },
      },
      documentButtonEdit: {
        textAlign: 'right',
        paddingRight: theme.spacing(4),
        boxSizing: 'border-box',
        '& .MuiIconButton-root': {
          fontSize: 11,
          borderColor: sicrediColor.primarySicredi,
          color: sicrediColor.primarySicredi,
          '&.Mui-disabled': {
            padding: theme.spacing(1, 2),
            borderRadius: 8,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'transparent',
            backgroundColor: sicrediColor.primarySicredi,
            color: 'white',
          }
        }
      },
      documentFormActions: {
        textAlign: 'right',
        padding: theme.spacing(1, 0),
        boxSizing: 'border-box',
        '& .MuiButton-text': {
          '&:first-of-type .MuiButton-startIcon': {
            color: sicrediColor.dangerSicredi,
          },
          '&:last-of-type .MuiButton-startIcon': {
            color: sicrediColor.primarySicredi,
          },
        }
      },
      documentCheckboxRow: {
        backgroundColor: sicrediColor.secondarySicrediLightest,
      },
      documentCheckboxLabel: {
        margin: 0,
        marginLeft: theme.spacing(4),
      },
      form: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(0, 4),
        boxSizing: 'border-box',
      },
      formFile: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        '& > .MuiButton-contained': {
          alignSelf: 'baseline',
        },
        '& > input[type="file"]': {
          width: 0,
          height: 0,
          opacity: 0,
        },
        '& > .MuiTypography-root': {
          marginTop: theme.spacing(2.5),
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
      },
      formEditData: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
      },
      formFlagCheckbox: {
        margin: theme.spacing(1, 0),
        alignSelf: 'baseline',
      },
      formDivider: {
        marginTop: theme.spacing(2.5),
      },
      formActions: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        textAlign: 'right',
        '& button:first-of-type': {
          marginRight: theme.spacing(3),
        }
      },
    }),
  { name: 'EditarDocumentosModal' }
);
